const REFRESH_COMPONENTS = "REFRESH_COMPONENTS";
const ADD_SEARCH_COMPONENTS = "ADD_SEARCH_COMPONENTS";
const ADD_EMPTY_SEARCH_COMPONENTS = "ADD_EMPTY_SEARCH_COMPONENTS";
const CLEAN_SEARCH = "CLEAN_SEARCH";

export {
    REFRESH_COMPONENTS,
    ADD_SEARCH_COMPONENTS,
    ADD_EMPTY_SEARCH_COMPONENTS,
    CLEAN_SEARCH,
};
